import { useNavigate, Link } from 'react-router-dom';
import { useCreateUser } from '../../../hooks/users/useCreateUser.js';
import { useCompaniesSelect } from '../../../hooks/company/useCompaniesSelect.js';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import ValidationErrors from '../../../components/alerts/ValidationErrors.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function CreateUser() {
    const navigate = useNavigate();
    const {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        resetForm,
        clearError,
        clearValidationErrors
    } = useCreateUser();
    const { companies, loading } = useCompaniesSelect();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await submit();
    };

    return (
        <>
            <div className='container mt-6'>
                <h1 className='text-center'>Registrar usuario</h1>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-7 mt-4 m-auto">
                        <div className="card mb-3">
                            <div className="pt-4 px-4 pt-md-5 px-md-5">
                                {/* Muestra el error del validator del backend */}
                                <ValidationErrors errors={validationErrors} onClose={clearValidationErrors} />
                                <form onSubmit={handleSubmit}>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingName" placeholder="Nombre" name="name" type="text" maxLength="100" value={form.name} onChange={handleChange} required />
                                        <label htmlFor="floatingName">Nombre *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                                                                
                                        <input className="form-control" id="floatingLastname" placeholder="Apellidos" name="lastname" type="text" maxLength="100" value={form.lastname} onChange={handleChange} required  />
                                        <label htmlFor="floatingLastname">Apellidos *</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" id="floatingCompany" name="companyid" value={form.companyid || 1} onChange={handleChange} disabled={loading}>
                                            {companies.map(company => (
                                                <option key={company.id} value={company.id}>
                                                    {company.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingCompany">Empresa</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingUsername" placeholder="Nombre de usuario" name="username" type="text" maxLength="30" value={form.username} onChange={handleChange} autoComplete="username" required /> 
                                        <label htmlFor="floatingUsername">Nombre de usuario *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                                                                    
                                        <input className="form-control" id="floatingEmail" placeholder="Email" name="email" type="email" maxLength="50" value={form.email} onChange={handleChange} autoComplete="email" required />
                                        <label htmlFor="floatingEmail">Email *</label>                                        
                                    </div>
                                    <div className="form-floating mb-3">                                                                                    
                                        <input className="form-control" id="floatingPassword" placeholder="Contraseña" name="password" type="password" maxLength="255" value={form.password} onChange={handleChange} autoComplete="new-password" required />
                                        <label htmlFor="floatingPassword">Contraseña *</label>
                                    </div>
                                    <div className="form-floating mb-3">                                                       
                                        <textarea className="form-control" id="floatingDescription" placeholder="Comentarios" name="description" maxLength="255" value={form.description} onChange={handleChange} style={{height:"100px"}} ></textarea>
                                        <label htmlFor="floatingDescription">Comentarios</label>                                        
                                    </div>
                                    <div className="mt-5 mb-4 text-end">
                                        <button type="submit" className="btn btn-primary">Guardar</button>
                                        <Link to={ROUTES.LINKROOTUSER}  type="button" className="ms-3 btn btn-secondary">Cancelar</Link>                                                
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessModal
                show={!!success}
                message={success}
                onClose={() => {
                    resetForm();
                    navigate(ROUTES.CREATEUSER);
                }}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={clearError}
            />
        </>
    );
}